module.exports = __webpack_public_path__ + "img/ods.8381d8db.svg";